export const iconFontAwesomeFoodBeverageAppleWhole = (
	<i className="fa-solid fa-apple-whole"></i>
);
